import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { WhatItIsSection } from '../components/WhatItIsSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { IncludesSection } from '../components/IncludesSection';
import { TableOfContentsSection } from '../components/TableOfContentsSection';
import { AudienceSection } from '../components/AudienceSection';
import { PricingSection } from '../components/PricingSection';
import { FaqSection } from '../components/FaqSection';
import { UpsellSection } from '../components/UpsellSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-900 text-slate-50 font-sans selection:bg-blue-500/30" data-id="element-186">
      <HeroSection data-id="element-187" />
      <PainPointsSection data-id="element-188" />
      <WhatItIsSection data-id="element-189" />
      <BenefitsSection data-id="element-190" />
      <IncludesSection data-id="element-191" />
      <TableOfContentsSection data-id="element-192" />
      <AudienceSection data-id="element-193" />
      <PricingSection data-id="element-194" />
      <FaqSection data-id="element-195" />
      <UpsellSection data-id="element-196" />
      <Footer data-id="element-197" />
    </div>;
}